// src/pages/Admin/CoursAgenda/components/CoursAgendaHeader.jsx

import React from "react";

import {
  FaCalendarAlt,
  FaMapMarkerAlt,
  FaPlus,
  FaUser,
  FaUserFriends,
} from "react-icons/fa";

const Stat = ({
  icon: Icon,
  value,
  label,
}) => (
  <div className="rounded-xl border border-white/10 bg-white/10 px-3 py-3 backdrop-blur">
    <div className="flex items-center gap-2">
      <Icon className="text-red-300" />

      <span className="text-lg font-bold text-white">
        {value}
      </span>
    </div>

    <p className="mt-1 text-xs text-slate-300">
      {label}
    </p>
  </div>
);

const CoursAgendaHeader = ({
  totalCours = 0,
  totalEnseignants = 0,
  totalAssistants = 0,
  totalLieux = 0,

  onCreate,
}) => (
  <section
    className="
      overflow-hidden
      rounded-3xl
      bg-gradient-to-br
      from-slate-950
      via-slate-900
      to-red-950
      p-5
      shadow-xl
      sm:p-7
    "
  >
    <div className="flex flex-col gap-6 xl:flex-row xl:items-end xl:justify-between">
      <div>
        <div className="mb-3 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/10 px-3 py-1.5 text-xs font-semibold uppercase tracking-wider text-slate-200">
          <FaCalendarAlt className="text-red-400" />
          Administration
        </div>

        <h1 className="text-2xl font-bold tracking-tight text-white sm:text-3xl lg:text-4xl">
          Agenda des cours
        </h1>

        <p className="mt-2 max-w-2xl text-sm leading-6 text-slate-300">
          Visualisez les cours de Krav Maga par semaine,
          gérez les horaires et organisez les équipes
          d'instructeurs et d'assistants.
        </p>
      </div>

      <button
        type="button"
        onClick={onCreate}
        className="
          flex shrink-0 items-center justify-center
          gap-2
          rounded-xl
          bg-red-600
          px-5 py-3
          text-sm font-bold
          text-white
          shadow-lg shadow-red-950/30
          transition
          hover:bg-red-500
        "
      >
        <FaPlus />
        Ajouter un cours
      </button>
    </div>

    <div className="mt-6 grid grid-cols-2 gap-2 sm:grid-cols-4">
      <Stat
        icon={FaCalendarAlt}
        value={totalCours}
        label="Cours"
      />

      <Stat
        icon={FaUser}
        value={totalEnseignants}
        label="Instructeurs"
      />

      <Stat
        icon={FaUserFriends}
        value={totalAssistants}
        label="Assistants"
      />

      <Stat
        icon={FaMapMarkerAlt}
        value={totalLieux}
        label="Lieux"
      />
    </div>
  </section>
);

export default CoursAgendaHeader;